import React from 'react';
import FeatureCard from './components/FeatureCard';

function App() {
  return (
    <div className="App">
      <header>
        <div className="container">
          <nav className="navbar">
            <div className="logo">
              <img src="/images/logo.png" alt="FTR Logo" />
              <h1>FTR Hasta Takip</h1>
            </div>
            <ul className="nav-links">
              <li><a href="#features">Özellikler</a></li>
              <li><a href="#about">Hakkında</a></li>
              <li><a href="#contact">İletişim</a></li>
            </ul>
          </nav>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <h2>Fizyoterapistler için Geliştirilmiş Hasta Takip Sistemi</h2>
          <p>
            Hasta verilerinizi kolayca yönetin, seans haklarını takip edin ve WhatsApp ile paylaşın.
          </p>
          <div className="hero-buttons">
            <a href="#features" className="btn btn-secondary">Özellikleri Keşfet</a>
          </div>
          <p className="contact-info">
            Hesap oluşturmak için <a href="mailto:tankut.alperen@gmail.com">bizimle iletişime geçin</a>
          </p>
          <div className="app-screenshot">
            <img src="/images/1.png" alt="FTR Hasta Takip Uygulaması" />
          </div>
        </div>
      </section>

      <section className="features" id="features">
        <div className="container">
          <div className="section-title">
            <h3>Özellikler</h3>
            <p>FTR Hasta Takip uygulaması ile fizyoterapi süreçlerinizi kolaylaştırın.</p>
          </div>
          <div className="features-grid">
            <FeatureCard 
              icon={<i className="fas fa-user-plus"></i>}
              title="Hasta Ekle ve Düzenle"
              description="Hasta verilerini kolayca ekleyin, düzenleyin ve takip edin."
            />
            <FeatureCard 
              icon={<i className="fas fa-calendar-check"></i>}
              title="Seans Takibi"
              description="Hastaların seans haklarını otomatik olarak hesaplayın ve takip edin."
            />
            <FeatureCard 
              icon={<i className="fab fa-whatsapp"></i>}
              title="WhatsApp Entegrasyonu"
              description="Hasta verilerini kolayca WhatsApp üzerinden paylaşın."
            />
            <FeatureCard 
              icon={<i className="fas fa-map-marker-alt"></i>}
              title="Konum Takibi"
              description="Hastaların konumlarını kolayca görüntüleyin."
            />
            <FeatureCard 
              icon={<i className="fas fa-list-ol"></i>}
              title="Otomatik Saatlendirme"
              description="Seçilen hastalara otomatik olarak seans saatleri atayın."
            />
            <FeatureCard 
              icon={<i className="fas fa-mobile-alt"></i>}
              title="Mobil Erişim"
              description="iOS ve Android cihazlardan her yerden erişim sağlayın."
            />
          </div>
          <div className="app-screenshot-additional">
            <img src="/images/3.png" alt="FTR Hasta Takip Ekran Görüntüsü" />
          </div>
        </div>
      </section>

      <section className="about" id="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h3>FTR Hasta Takip Hakkında</h3>
              <p>
                FTR Hasta Takip uygulaması, fizyoterapistlerin günlük hasta verilerini kolayca yönetmeleri, hastaların seans haklarını takip etmeleri ve ekip içi iletişimi güçlendirmeleri için özel olarak tasarlanmıştır.
              </p>
              <p>
                Sistem Firebase veritabanı kullanarak verileri güvenli bir şekilde saklar ve React Native teknolojisi ile geliştirilmiştir. Bu sayede hem iOS hem de Android cihazlarda sorunsuz çalışır.
              </p>
              <a href="#" className="btn">Daha Fazla Bilgi</a>
            </div>
            <div className="about-image">
              <img src="/images/2.png" alt="FTR Hasta Takip" />
            </div>
          </div>
        </div>
      </section>

      <footer id="contact">
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h4>FTR Hasta Takip</h4>
              <ul>
                <li><a href="#features">Özellikler</a></li>
                <li><a href="#about">Hakkında</a></li>
                <li><a href="#">Fiyatlandırma</a></li>
                <li><a href="#">Yardım</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>İletişim</h4>
              <ul>
                <li><a href="mailto:tankut.alperen@gmail.com">tankut.alperen@gmail.com</a></li>
              </ul>
            </div>
          </div>
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} FTR Hasta Takip. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
